import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Switch as AriaSwitch } from "react-aria-components";
import { Text } from "./Checkbox.js";
import { Spinner } from "./Spinner.js";
import { indicator, loadingIndicator, wrapper } from "./Toggle.css.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BaseToggle = (t0, ref) => {
  const $ = _c(21);
  let children;
  let loadingLabel;
  let props;
  let supportingText;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      size: t1,
      children,
      supportingText,
      isLoading: t2,
      loadingLabel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = loadingLabel;
    $[3] = props;
    $[4] = supportingText;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    loadingLabel = $[2];
    props = $[3];
    supportingText = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const size = t1 === undefined ? "m" : t1;
  const isLoading = t2 === undefined ? false : t2;
  const coercedSize = size === "xs" ? "s" : size;
  let t3;
  if ($[7] !== coercedSize) {
    t3 = wrapper({
      size: coercedSize
    });
    $[7] = coercedSize;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== coercedSize || $[11] !== isLoading || $[12] !== loadingLabel || $[13] !== size || $[14] !== supportingText) {
    t4 = t5 => {
      const {
        isSelected
      } = t5;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: indicator({
            size: coercedSize
          }),
          children: isLoading && /*#__PURE__*/_jsx("div", {
            className: loadingIndicator,
            children: /*#__PURE__*/_jsx(Spinner, {
              size: coercedSize,
              color: isSelected ? "white" : "royalBlue",
              "aria-label": loadingLabel
            })
          })
        }), children != null && (size === "xs" ? /*#__PURE__*/_jsx(Text, {
          size: size,
          children: children
        }) : /*#__PURE__*/_jsx(Text, {
          supportingText: supportingText,
          size: size,
          children: children
        }))]
      });
    };
    $[9] = children;
    $[10] = coercedSize;
    $[11] = isLoading;
    $[12] = loadingLabel;
    $[13] = size;
    $[14] = supportingText;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== props || $[17] !== ref || $[18] !== t3 || $[19] !== t4) {
    t5 = /*#__PURE__*/_jsx(AriaSwitch, {
      ref: ref,
      ...props,
      className: t3,
      children: t4
    });
    $[16] = props;
    $[17] = ref;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};

/***
 * Primary UI component for user interaction
 */
export const Toggle = /*#__PURE__*/React.forwardRef(BaseToggle);
//# sourceMappingURL=Toggle.js.map